export function disabledTransformation<T extends Function>(disabled?: boolean, action?: T) {
  if (disabled) {
    return () => {};
  }

  return action;
}
